/* jshint esversion: 6 */
import React from 'react';
import UpgradeModal from 'app/components/Subscription/UpgradeModal.jsx';
import AddOnChangeConfirm from 'app/components/Subscription/Confirm/AddOnChangeConfirm.jsx';

export default function SubscriptionModule(Component) {
    return class SubscriptionModule extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                isUpgradeModalVisible: false
            };

            this.showUpgradeModal = this.showUpgradeModal.bind(this);
            this.updateSocialAddOns = this.updateSocialAddOns.bind(this);

        }

        showUpgradeModal(modalHandler, context, errors, trigger) {
            let modal = null,
                errorCode = 0,
                currentPath = '',
                showCTA = true,
                constants = this.props.app.config.constants;

            const modalHandlerWrapper = () => {
                this.setState({
                    isUpgradeModalVisible: false
                });
                modalHandler.apply(this, []);
            };

            if (context !== '' && context !== null) {
                if (context === 'clients' || context === 'clientSeatLimit' || context === 'usersLimit') {
                    showCTA = false;
                }
                modal = (
                    <UpgradeModal
                        {...this.props}
                        context={context}
                        trigger={trigger}
                        modalHandler={modalHandlerWrapper}
                        showCTA={showCTA}/>
                );
            } else if (errors){
                if (errors.errors && errors.errors.perms) {
                    errorCode = errors.errors.perms.code;
                } else {
                    for (let key in errors) {
                        if (errors[key].errors && errors[key].errors.perms) {
                            errorCode = errors[key].errors.perms.code;
                            break;
                        }
                    }
                }
                if (errorCode) {
                    if (errorCode === constants.P_CLIENT_ACCTS || errorCode === constants.P_CLIENT_ACCT_LIMIT) {
                        showCTA = false;
                    }
                    modal = (
                        <UpgradeModal
                            {...this.props}
                            errorCode={errorCode}
                            trigger={trigger}
                            modalHandler={modalHandlerWrapper}
                            showCTA={showCTA}/>
                    );
                }
            }

            if (modal !== null) {
                if (this.props.router.location) {
                    currentPath = this.props.router.location.pathname;
                    // TODO: make this work
                    //this.props.recordPath(currentPath);
                }

                this.setState({
                    isUpgradeModalVisible: true
                }, () => {
                    this.props.closeOtherModals(modal);
                });
            }
        }

        updateSocialAddOns(quantity) {
            this.props.closeOtherModals(
                <AddOnChangeConfirm
                    {...this.props}
                    addOn="add_on_social"
                    quantity={quantity}
                    onConfirm={() => {
                        this.props.updateAddOns({
                            add_on_social: quantity
                        });
                    }}
                    onCancel={() => {
                        this.setState({
                            isUpgradeModalVisible: false
                        });
                    }} />
            );
        }

        render() {
            return (
                <Component
                    {...this.props}
                    showUpgradeModal={this.showUpgradeModal}
                    isUpgradeModalVisible={this.state.isUpgradeModalVisible}
                    updateSocialAddOns={this.updateSocialAddOns}/>
            );
        }

    }

    SubscriptionModule.displayName = "SubscriptionModule";
};
